import { snakeCase } from 'change-case';

export const recipientGroupSlug = (group: string): string => {
  return `POLLS.RECIPIENT_GROUPS.${snakeCase(group).toUpperCase()}`;
};
